import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {WcvDocument} from '../../../graphql/documents.datatypes';
import {gqlDocument} from '../getDocument.api';

interface DeleteDocumentInput {
    id: number
}

interface DeleteDocumentData {
    deleteDocument: WcvDocument
}

export const DELETE_ROOM_PARTY_MUTATION = gql`
    mutation deleteDocument($id: Int!) {
        deleteDocument(id: $id) {
            ${gqlDocument}
        }
    }
`;

export const deleteDocument = () => useMutation<DeleteDocumentData, DeleteDocumentInput>(
    DELETE_ROOM_PARTY_MUTATION,
    {
        update: updateCacheByType('Document'),
    }
);

export default deleteDocument;